(() => {
  const DATA_SELECTOR = '[data-bm-collection-gallery-data]';
  const CARD_SELECTOR = '[data-bm-product-card]';

  function productHandleFromCard(card) {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';

    try {
      const url = new URL(link.getAttribute('href'), window.location.origin);
      const match = url.pathname.match(/\/products\/([^/]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function readGalleryData() {
    const source = document.querySelector(DATA_SELECTOR);
    if (!source) return new Map();

    try {
      const products = JSON.parse(source.textContent || '[]');
      return new Map(
        products
          .filter((product) => product && product.handle && Array.isArray(product.images))
          .map((product) => [
            product.handle,
            product.images.filter(Boolean)
          ])
      );
    } catch (error) {
      console.error('BarberMarket gallery: no se pudo leer la galería.', error);
      return new Map();
    }
  }

  function createArrow(direction, label) {
    const control = document.createElement('span');
    control.className = `bm-card-gallery__arrow bm-card-gallery__arrow--${direction}`;
    control.setAttribute('role', 'button');
    control.setAttribute('tabindex', '0');
    control.setAttribute('aria-label', label);
    control.textContent = direction === 'prev' ? '‹' : '›';
    return control;
  }

  function initializeCard(card, images) {
    if (card.dataset.bmGalleryCardReady === 'true') return;
    if (!Array.isArray(images) || images.length <= 1) return;

    const media = card.querySelector('.bm-card-media');
    const image = media?.querySelector('img');
    if (!media || !image) return;

    card.dataset.bmGalleryCardReady = 'true';
    media.dataset.bmGalleryReady = 'true';

    const originalSrc = image.currentSrc || image.src || images[0];
    const originalSrcset = image.getAttribute('srcset') || '';
    const originalSizes = image.getAttribute('sizes') || '';

    let currentIndex = 0;
    let preloaded = false;
    let resetTimer = null;

    const counter = document.createElement('span');
    counter.className = 'bm-card-gallery__counter';
    counter.setAttribute('aria-hidden', 'true');
    counter.innerHTML = `
      <span class="bm-card-gallery__counter-current" data-bm-gallery-current>1</span>
      <span class="bm-card-gallery__counter-separator">/</span>
      <span class="bm-card-gallery__counter-total">${images.length}</span>
    `;

    const previous = createArrow('prev', 'Foto anterior');
    const next = createArrow('next', 'Foto siguiente');

    const segments = document.createElement('span');
    segments.className = 'bm-card-gallery__segments';
    segments.setAttribute('aria-hidden', 'true');

    images.forEach((_, index) => {
      const segment = document.createElement('span');
      segment.className = 'bm-card-gallery__segment';
      if (index === 0) segment.classList.add('is-active');
      segments.appendChild(segment);
    });

    media.appendChild(previous);
    media.appendChild(next);
    media.appendChild(segments);
    media.appendChild(counter);

    const currentOutput = counter.querySelector('[data-bm-gallery-current]');
    const segmentItems = Array.from(segments.children);

    function preloadImages() {
      if (preloaded) return;
      preloaded = true;

      images.slice(1).forEach((src) => {
        const preload = new Image();
        preload.src = src;
      });
    }

    function updateUI(index) {
      if (currentOutput) currentOutput.textContent = String(index + 1);
      segmentItems.forEach((segment, segmentIndex) => {
        segment.classList.toggle('is-active', segmentIndex === index);
      });
    }

    function show(index, { reset = false } = {}) {
      const normalized = ((index % images.length) + images.length) % images.length;
      if (normalized === currentIndex && !reset) return;

      currentIndex = normalized;
      updateUI(currentIndex);

      image.classList.add('is-bm-gallery-changing');

      if (reset && currentIndex === 0) {
        image.src = originalSrc;

        if (originalSrcset) {
          image.setAttribute('srcset', originalSrcset);
        } else {
          image.removeAttribute('srcset');
        }

        if (originalSizes) {
          image.setAttribute('sizes', originalSizes);
        }
      } else {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = images[currentIndex];
      }

      const finish = () => image.classList.remove('is-bm-gallery-changing');

      if (image.complete) {
        window.requestAnimationFrame(finish);
      } else {
        image.addEventListener('load', finish, { once: true });
      }
    }

    function move(direction) {
      window.clearTimeout(resetTimer);
      preloadImages();
      show(currentIndex + direction);
    }

    function bindControl(control, direction) {
      const activate = (event) => {
        event.preventDefault();
        event.stopPropagation();
        move(direction);
      };

      control.addEventListener('click', activate);
      control.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') activate(event);
      });
    }

    bindControl(previous, -1);
    bindControl(next, 1);

    media.addEventListener('mouseenter', () => {
      window.clearTimeout(resetTimer);
      preloadImages();
    });

    media.addEventListener('mousemove', (event) => {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      if (event.target.closest('.bm-card-gallery__arrow')) return;

      const rect = media.getBoundingClientRect();
      if (!rect.width) return;

      const relativeX = Math.min(rect.width - 1, Math.max(0, event.clientX - rect.left));
      const index = Math.min(images.length - 1, Math.floor((relativeX / rect.width) * images.length));
      show(index);
    });

    media.addEventListener('mouseleave', () => {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

      window.clearTimeout(resetTimer);
      resetTimer = window.setTimeout(() => {
        currentIndex = 0;
        updateUI(0);
        show(0, { reset: true });
      }, 90);
    });
  }

  function initialize() {
    const galleries = readGalleryData();
    if (galleries.size === 0) return;

    document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      const handle = productHandleFromCard(card);
      const images = galleries.get(handle);
      initializeCard(card, images);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
